import axios from 'axios'
import { ElMessage, ElNotification } from "element-plus"
import { useRouter } from 'vue-router'
import { useUserStore } from '../pinia/userStore'

const router = useRouter();
//const userStore = useUserStore()

const service = axios.create({
    baseURL: '/employee', // 基础URL
    timeout: 300000, // 请求超时时间
    headers: {
        "Content-Type": "multipart/form-data"
    }
})

// 请求拦截器：添加Token
service.interceptors.request.use(
  (config) => {
      const token = localStorage.getItem('ai_employee_token')
      if (token) {
          config.headers.Authorization = token
          config.headers.source = "web"
      }
      return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器：统一处理结果
service.interceptors.response.use(success => {
    if (localStorage.getItem('ai_employee_token') == null || localStorage.getItem('ai_employee_token') == '') {
        window.location.href = '/login';
        return false;
    } else {
        //业务逻辑错误
        if (success.status && success.status == 200) {
            if (success.data.code == 500 || success.data.code == 403) {
                ElNotification({
                    message: success.data.message,
                    type: "error",
                })
                return success.data
            } else if (success.data.code == 401) {
                //window.localStorage.removeItem("user_token");
                //router.replace("/");
                //router.push("/login");
                ElNotification({
                    message: success.data.message,
                    type: "error",
                })
                //router.push("/login");
                localStorage.removeItem("ai_employee_token");
                localStorage.removeItem("ai_employee_userInfo");
                window.location.href = '/login';
            } else if (success.data.message) {
                ElNotification({
                    message: success.data.message,
                    type: "success",
                })
            }
        }
        return success.data
    }
}, error => {
    if (error.response.code == 504 || error.response.code == 404) {
        ElNotification({
            message: "服务器调用错误！",
            type: "error",
        })
    } else if (error.response.code == 403) {
        ElNotification({
            message: "权限不足，请联系管理员！",
            type: "error",
        })
    } else if (error.response.code == 401) {
        ElNotification({
            message: "尚未登录，请登录！",
            type: "error",
        })
        //router.replace('/');
    } else {
        if (error.response.data.message) {
            ElNotification({
                message: error.response.data.message,
                type: "error",
            })
        } else {
            ElNotification({
                message: "未知错误！",
                type: "error",
            })
        }
    }
    return Promise.reject(new Error(data.message || 'Error'))
})
/*service.interceptors.response.use(
  (response) => response.data,
  (error) => {
      console.error('请求错误：', error)
      return Promise.reject(error)
  }
)*/

export default service

/*import axios from "axios"
import { ElMessage } from "element-plus"

const service = axios.create({
    baseURL: '/employee', // 基础URL
    timeout: 30000, // 请求超时时间
    headers: {
        "Content-Type": "application/json;charset=utf-8"
    }
})

service.interceptors.request.use(config => {
    // 为请求头添加x-access-token字段为服务端返回的token
    const token = localStorage.getItem("aiEmployeeTokenStr")
    config.headers.Authorization = token
    config.headers.source = "web"
    // return config是固定用法 必须有返回值
    return config
}, function(error) {
    // 对请求错误做些什么
    return Promise.reject(error)
})

service.interceptors.response.use(success => {
    //业务逻辑错误
    if (success.status && success.status == 200) {
        if (success.data.code == 500 || success.data.code == 403) {
            ElMessage.error({ message: success.data.message })
            return
        } else if (success.data.code == 401) {
            //window.localStorage.removeItem("user_token");
            //router.replace("/");
            ElMessage.error({ message: success.data.message })
            return
        } else if (success.data.message) {
            ElMessage.success({ message: success.data.message })
        }
    }
    return success.data
}, error => {
    if (error.response.code == 504 || error.response.code == 404) {
        ElMessage.error({ message: "服务器调用错误！" })
    } else if (error.response.code == 403) {
        ElMessage.error({ message: "权限不足，请联系管理员！" })
    } else if (error.response.code == 401) {
        ElMessage.error({ message: "尚未登录，请登录！" })
        //router.replace('/');
    } else {
        if (error.response.data.message) {
            ElMessage.error({ message: error.response.data.message })
        } else {
            ElMessage.error({ message: "未知错误！" })
        }
    }
    return Promise.reject(new Error(data.message || 'Error'))
})

export default service*/
